"use client";

import {
  Button,
  clickOutSideToClose,
  Dropdown,
  DropdownItem,
  Heading,
  Icon,
} from "daskapital-ds";

import { Language } from "@/lib/helpers/getI18n";
import Link from "next/link";
import { useGlobalContext } from "@/lib/globalContext";
import { createRef, useCallback, useMemo, useState } from "react";
import styled from "styled-components";
import { useRouter, usePathname } from "next/navigation";

const Switcher = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  font-family: var(--font-alternative);
`;

const SwitcherTrigger = styled.div`
  background: transparent;
  position: relative;
  height: 40px;
  display: flex;
  align-items: center;
  gap: 8px;

  &:hover {
    cursor: pointer;
  }
`;

const SwitcherIcon = styled.span<{ open: boolean }>`
  display: inline-flex;
  transition: transform 0.2s ease-in-out;
  transform: rotate(${(props) => (props.open ? "180deg" : "0deg")});
`;

const SwitcherContent = styled.div`
  background: white;
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 100%;
  overflow: hidden;
  right: 0;
  left: auto;
  opacity: 0;
  pointer-events: none;
  transform: translate(0, -4px);
  transition: all 0.4s;
  border-radius: 8px;
  &[data-open="true"] {
    opacity: 1;
    pointer-events: auto;
    transform: translate(0, 0);
  }
  @media all and (max-width: 768px) {
    left: 0;
    right: auto;
  }
`;

const SwitcherLink = styled.div`
  color: black;
  margin: 8px 0;
  padding: 10px 20px;

  &:hover {
    cursor: pointer;
    color: var(--color-primary50);
  }
`;

const LanguageSwitcher = () => {
  const state = useGlobalContext();
  const { setLang } = state;
  const [selectedLanguage, setSelectedLanguage] = useState(state?.lang);
  const [toggleSwitch, setToggleSwitch] = useState(false);

  const currentLanguage = useMemo(() => {
    const languageData = state?.i18n?.languages.filter(
      (x: Language) => x.code === selectedLanguage
    );
    return languageData[0].name || "English";
  }, [selectedLanguage]);

  const findLanguageName = useCallback((code: string) => {
    if (!code) return null;
    const languageData = state?.i18n?.languages.filter(
      (x: Language) => x.code === code
    );
    return languageData[0].name || "English";
  }, []);

  const handleLanguage = useCallback(
    (locale: string) => {
      setSelectedLanguage(locale);
      setToggleSwitch(false);
      setLang && setLang(locale);
    },
    [state]
  );

  const itemsContainerRef = createRef<HTMLDivElement>();
  clickOutSideToClose(itemsContainerRef, () => setToggleSwitch(false));

  return (
    <Switcher
      onMouseEnter={() => setToggleSwitch(true)}
      onMouseLeave={() => setToggleSwitch(false)}
    >
      <SwitcherTrigger onClick={() => setToggleSwitch(!toggleSwitch)}>
        <span>{selectedLanguage?.toUpperCase()}</span>
        <SwitcherIcon open={toggleSwitch}>
          <Icon icon="icon-chevron-down" />
        </SwitcherIcon>
      </SwitcherTrigger>

      <SwitcherContent ref={itemsContainerRef} data-open={toggleSwitch}>
        {state?.i18n?.locales.map((locale: string) => (
          <SwitcherLink key={locale}>
            <Link
              href={state?.translatedUri?.[locale] || `/${locale}`}
              prefetch={true}
              onClick={() => handleLanguage(locale)}
            >
              {locale.toUpperCase()}
            </Link>
          </SwitcherLink>
        ))}
      </SwitcherContent>
    </Switcher>
  );
  // return (
  // 	<>
  // 		{state?.i18n.locales && (
  // 			<Dropdown
  // 				title={
  // 					<Heading tag={'span'} size={'texts'} style={{ color: 'currentcolor' }}>
  // 						{state?.i18n?.languages.filter((x: Language) => x.code === state.lang)[0].name}
  // 					</Heading>
  // 				}
  // 				icon={<Icon icon="icon-chevron-down" />}
  // 				style={{ verticalAlign: 'middle' }}>
  // 				{state?.i18n?.locales.map((locale: string) => {
  // 					return (
  // 						<DropdownItem key={`lang-${locale}`}>
  // 							<Link href={state.translatedUri && state.translatedUri[locale] ? state.translatedUri[locale] : `/${locale}/`}>
  // 								<Heading tag="span" size="texts" className={state.lang === locale ? 'color-primary50' : ''}>
  // 									{state?.i18n?.languages.filter((x: Language) => x.code === locale)[0].name}
  // 								</Heading>
  // 							</Link>
  // 						</DropdownItem>
  // 					);
  // 				})}
  // 			</Dropdown>
  // 		)}
  // 	</>
  // );
};

export default LanguageSwitcher;
